/**
 * @Description 商务条件（businessTerms）定制组件的共享配置
 * 表单编辑态与只读详情/PDF 共用同一份计费方式定义，避免两处硬编码不一致
 */

/** 计费方式内部值 */
// 服务端 type：1-纯租金，2-纯扣点，3-租金+扣点，4-两者取高。
export const BusinessTermsType = {
  /** 纯租金 */
  PURE_RENT: 1,
  /** 纯扣点 */
  PURE_POINT: 2,
  /** 租金+扣点 */
  RENT_PLUS_POINT: 3,
  /** 两者取高 */
  MAX: 4,
};

/** 计费方式选项（内部值 <-> 中文名），内部值与后端约定不一致时仅需调整此处 */
export const BILLING_METHOD_OPTIONS = [
  { value: BusinessTermsType.PURE_RENT, label: '纯租金' },
  { value: BusinessTermsType.PURE_POINT, label: '纯扣点' },
  { value: BusinessTermsType.RENT_PLUS_POINT, label: '租金+扣点' },
  { value: BusinessTermsType.MAX, label: '两者取高' },
];

/** 默认计费方式（PRD：默认「纯租金」） */
export const DEFAULT_BILLING_METHOD = BusinessTermsType.PURE_RENT;

/** 需要展示「月租金」的计费方式 */
export const MONTHLY_RENT_METHODS: number[] = [
  BusinessTermsType.PURE_RENT,
  BusinessTermsType.RENT_PLUS_POINT,
  BusinessTermsType.MAX,
];

/** 需要展示「扣点比例」的计费方式 */
export const DEDUCTION_RATIO_METHODS: number[] = [
  BusinessTermsType.PURE_POINT,
  BusinessTermsType.RENT_PLUS_POINT,
  BusinessTermsType.MAX,
];

/**
 * @description 获取计费方式的中文名
 * @param type 计费方式内部值
 * @return 中文名，未匹配时返回空字符串
 */
export const getBusinessTermsTypeName = (type: any) => {
  const target = BILLING_METHOD_OPTIONS.find((item) => item.value === type);
  return target ? target.label : '';
};

/** @description 当前计费方式下是否展示「月租金」 */
export const isShowRent = (type: any) => MONTHLY_RENT_METHODS.includes(type);

/** @description 当前计费方式下是否展示「扣点比例」 */
export const isShowDiscount = (type: any) => DEDUCTION_RATIO_METHODS.includes(type);
